import { SelectInputAsync } from '../Form'

export const ListSuggestionsItem = ({ handleOnSelect, selectedValue, loadOptions }) => {
  return (
    <SelectInputAsync selectedValue={selectedValue} loadOptions={loadOptions} onChange={handleOnSelect} placeholder="Faça uma pergunta para retornar uma questão" />
  )
}